<template>
  <div class="content">
    <el-select v-model="value" :placeholder="gestitle">
      <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  props: ['options','title'],
  watch:{
  options : 'getoptions',
  title:'gettitle',
},
  data() {
    return {
      list:'',
      value: '',
      gestitle: '',
    };
  },
  methods: {
    getoptions(){
      this.list = this.options
    },
    gettitle(){
      this.gestitle = this.title
    }
  },
  created: async function() {
    let self = this;
    self.getoptions()
    self.gettitle()
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
</style>
